export default __webpack_public_path__ + "static/ringcentral-75d1fd7f01b8a8f6b9d8847efaa18445.png";